import { Toggle } from "@dropbox/dig-components/controls";
import { FormLabel } from "@dropbox/dig-components/form_row";
import i18n from "@mirage/translations";
import { useNotificationSettings } from "./useNotificationSettings";

export const NotificationSettings = () => {
  const notificationSettings = useNotificationSettings();
  if (!notificationSettings.available) return null;

  return (
    <>
      <Toggle
        checked={notificationSettings.stackSharedSubscribed}
        onChange={({ target: { checked } }) =>
          notificationSettings.setStackSharedSubscribed(checked)
        }
      />
      <FormLabel variant="control">
        {i18n.t(
          notificationSettings.stackSharedSubscribed
            ? "settings_extension_on"
            : "settings_extension_off",
        )}
      </FormLabel>
    </>
  );
};
